// libs
import React, { memo, useEffect, useState } from "react";
import get from "lodash/get";

// helpers
import { getRecentSearches, clearSearches } from "shared/components/HeaderSearch/helpers";

// constants
import { TEXTS } from "shared/components/HeaderSearch/constants";

// styles
import { RecentSearchContainer, TitleContainer, ClearButton, Term } from "./styles";

// defs
import { ISearchInfo } from "shared/components/HeaderSearch/types";
interface IRecentSearchProps {
    onSelect: (searchInfo: ISearchInfo) => void;
}

function RecentSearch({ onSelect }: IRecentSearchProps) {
    const [searches, setSearches] = useState<ISearchInfo[]>([]);

    useEffect(() => {
        const localSearches = getRecentSearches();
        setSearches(localSearches);
    }, []);

    const clear = () => {
        clearSearches();
        setSearches([]);
    };

    if (searches.length === 0) {
        return null;
    }

    return (
        <RecentSearchContainer>
            <TitleContainer>
                <div className="title">{TEXTS.RECENT_SEARCHES}</div>
                <ClearButton as="a" onClick={clear} data-test="recent-search-clear">
                    {TEXTS.CLEAR}
                </ClearButton>
            </TitleContainer>
            {searches.map((searchInfo: ISearchInfo) => {
                const term = get(searchInfo, "term", "");

                return (
                    <Term
                        key={term}
                        role="button"
                        aria-label={term}
                        onClick={() => onSelect(searchInfo)}
                        data-test="recent-search-term"
                    >
                        {term}
                    </Term>
                );
            })}
        </RecentSearchContainer>
    );
}

export default memo(RecentSearch);
